// @flow

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Header from '~/src/components/Header';
import EventsAndAnalytics from './components/EventsAndAnalytics';
import Footer from '~/src/components/Footer';

type Props = {
  eventsAndAnalyticsConfig: Object,
  eventsAndAnalyticsCode: Object,
  eventsList: Array<string>,
  events: Array<Object>,
  addEvent: Function,
  setFormConfig: Function,
}

@inject((stores: Object) => {
  const {
    eventsAndAnalyticsConfig,
    eventsAndAnalyticsCode,
    eventsList,
    addEvent,
    events,
  } = stores.homeStore;
  const {setFormConfig} = stores.editorStore;
  return {
    eventsAndAnalyticsConfig,
    eventsAndAnalyticsCode,
    eventsList,
    addEvent,
    events,
    setFormConfig
  };
})

@observer
class EventsPage extends Component<Props> {
  render() {
    return (
      <div className="container">
        <Header/>
        <EventsAndAnalytics
          config={this.props.eventsAndAnalyticsConfig}
          eventsList={this.props.eventsList}
          events={this.props.events}
          addEvent={this.props.addEvent}
          setFormConfig={this.props.setFormConfig}
        />
        <Footer/>
      </div>
    );
  }
}

export default EventsPage;
